import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private urlApi = environment.rootUrlApi + 'seguranca/usuario/login';

  constructor(private http: HttpClient) { }

  public ping(): Observable<any> {
    return this.http.get<any>(this.urlApi + '/ping');
  }

  public login(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi, dados);
  }
}
